import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100" style={{ background: "#F7F7F7" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={5} xxl={5}>
            <h2>Retail App Development Services We Provide</h2>
            <p>
              Accelerate your retail business with tailored retail{" "}
              <Link to="https://www.tekrevol.com/mobile-app-development">
                mobile app services
              </Link>{" "}
              that address modern challenges like customer engagement, secure
              transactions, and inventory management. TekRevol’s retail app
              development services focus on leveraging advanced technologies to
              help businesses of all sizes streamline operations, increase
              customer retention, and scale efficiently with speed and security.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Start with a Free Consultation
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>Custom eCommerce Apps</h4>
                  <p>
                    Deliver a seamless shopping experience with fully integrated
                    eCommerce apps that connect to your inventory, payment
                    systems, and CRM in real time. Our apps are built for
                    performance, supporting high-traffic transactions and fast
                    checkouts to drive higher conversion rates.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Retail POS Systems</h4>
                  <p>
                    Our mobile POS apps sync across devices, giving retail
                    businesses a fast, secure, and easy-to-use point-of-sale
                    system. Featuring real-time inventory tracking, sales
                    reporting, and integration with payment gateways, this
                    solution enhances in-store efficiency.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>AI-Driven Customer Engagement</h4>
                  <p>
                    Leverage AI-powered personalization to offer real-time
                    product recommendations, automate marketing campaigns, and
                    engage users with predictive insights. Our AI modules help
                    retailers improve customer satisfaction and retention with
                    data-driven strategies.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Multi-Platform Omnichannel Apps</h4>
                  <p>
                    Create a unified shopping experience across web, mobile, and
                    in-store channels. Our omnichannel apps provide seamless
                    integration with existing systems, enabling consistent
                    customer experiences across platforms and devices.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Retail Data Analytics</h4>
                  <p>
                    Turn data into actionable insights with custom-built retail
                    analytics dashboards. From sales trends to customer
                    behavior, our analytics solutions provide retailers with the
                    metrics they need to make data-driven decisions that improve
                    profitability and customer satisfaction.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Secure Mobile Payment Integration</h4>
                  <p>
                    Ensure secure and efficient payment processing with apps
                    that support multi-currency, multiple payment gateways, and
                    end-to-end encryption. Our payment integration solutions
                    meet global compliance standards, protecting your business
                    and customers from fraud.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
